var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tabs.length > 0)?_c('Tabs',_vm._l((_vm.tabs),function(tab){return _c('TabItem',{key:tab.text,attrs:{"title":tab.text,"to":tab.route,"icon":tab.icon,"active":tab.route.name === _vm.$route.name}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }